import { render, staticRenderFns } from "./PriceBookFormDialog.vue?vue&type=template&id=e4569df6&scoped=true"
import script from "./PriceBookFormDialog.vue?vue&type=script&lang=js"
export * from "./PriceBookFormDialog.vue?vue&type=script&lang=js"
import style0 from "./PriceBookFormDialog.vue?vue&type=style&index=0&id=e4569df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4569df6",
  null
  
)

export default component.exports